import { useTranslation } from 'react-i18next';

import { formatSpokenMonth } from '../utils/formatMonth';

/**
 * Props that make a recharts line chart an image named by its summary: what it shows, how many
 * series, and the months it spans. Recharts' own accessibility layer would make it a focusable,
 * unnamed "application"; the values are given to screen readers by `TrendDataTable` instead.
 */
export const useTrendChartProps = (
  title: string,
  series: string[],
  points: ReadonlyArray<{ month: string }>,
) => {
  const { t, i18n } = useTranslation('analysis');
  const first = points.at(0);
  const last = points.at(-1);
  const label =
    first && last
      ? t('analysisResult.trendChart.summary', {
          title,
          count: series.length,
          from: formatSpokenMonth(first.month, i18n.language),
          to: formatSpokenMonth(last.month, i18n.language),
        })
      : title;
  return {
    accessibilityLayer: false,
    // eslint-disable-next-line i18next/no-literal-string -- an ARIA role, not copy
    role: 'img',
    'aria-label': label,
  } as const;
};
